const areaPageButton = document.querySelector(".js-visit-area-page-button");
const searchPageButton = document.querySelector(".js-visit-search-page-button");
const areaButtonsWrapper = document.querySelector(".map-card-nav-buttons");

export function updateAreaNavigation(currentArea) {
  if (!areaPageButton || !searchPageButton || !areaButtonsWrapper) return;

  if (!currentArea) {
    areaButtonsWrapper.classList.add("hidden");
    areaPageButton.classList.add("hidden");
    searchPageButton.classList.add("hidden");
    return;
  }

  if (currentArea.showAreaButton && currentArea.areaPageUrl) {
    areaPageButton.href = currentArea.areaPageUrl;
    areaPageButton.querySelector("span").textContent =
      " " + currentArea.areaName;
    areaPageButton.classList.remove("hidden");
  }
  if (currentArea.areaSearchPageUrl) {
    searchPageButton.href = currentArea.areaSearchPageUrl;

    searchPageButton.querySelector("span").textContent =
      " " + currentArea.areaName;
    searchPageButton.classList.remove("hidden");
  }
  areaButtonsWrapper.classList.remove("hidden");
}

export function getAreaInView(features) {
  let areaArray = [];
  features.forEach((prop) => {
    const area_alreadyInView = areaArray.some(
      (e) =>
        e.properties.area_name_without_zipcode ===
        prop.properties.area_name_without_zipcode
    );
    if (!area_alreadyInView) {
      areaArray.push(prop);
    }
  });

  if (areaArray.length === 1) {
    const areaInView = areaArray[0].properties;
    return {
      showAreaButton: areaInView.area_page_show_area_button_in_map,
      areaName: areaInView.area_name_without_zipcode,
      areaPageUrl: areaInView.area_page_url,
      areaSearchPageUrl: areaInView.area_search_page_url,
    };
  }

  return false;
}
